import React from 'react';
import PropTypes from 'prop-types';

IconContainer.propTypes = {
    color: PropTypes.string,
};

function IconContainer({color, ...props}) {
    return (
        <div style={{
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: color,
            borderRadius: '50%',
            padding: '4px'
        }}>
            {props.children}
        </div>
    );
}

export default IconContainer;
